var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDerecho(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#020C41;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.1,8c-0.1,2.7-2.4,4.8-5.1,4.7c-2.7-0.1-4.8-2.4-4.7-5.1c0.1-2.7,2.4-4.8,5.1-4.7C28.1,3,30.2,5.3,30.1,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.2,33.6l-6.5-4.1l-0.6-6.2c-0.4-3.2-2.3-5.5-5.4-5.4c-2.7,0.1-4.8,2.5-5,5.2L23,37.7c0,0,0.2,2.4,1.4,3.3 c1.2,0.9,4,1,4,1h13.9h0l8.3,15.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "9.4,26.7 13.9,26.7 21.3,48 38.4,48  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerecho);
export default __webpack_public_path__ + "static/media/derecho.d83bd13a64ceecffb7390befe93c7ad4.svg";
export { ForwardRef as ReactComponent };